import { ValueObjectMetaPredefinedDatetime } from "../meta";

export const predefinedDatetimeMeta = new ValueObjectMetaPredefinedDatetime();
